import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-semibold text-white md:text-4xl text-3xl" }




export default /*#__PURE__*/_defineComponent({
  __name: 'BigTitle',
  props: {
    title: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(props.title), 1))
}
}

})